import { render, staticRenderFns } from "./CustomerRegistrationForm.vue?vue&type=template&id=37cf8c80&"
import script from "./CustomerRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports